import { render, staticRenderFns } from "./LowCostForm.vue?vue&type=template&id=4c3ef915&scoped=true&"
import script from "./LowCostForm.vue?vue&type=script&lang=js&"
export * from "./LowCostForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3ef915",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VCol,VRow,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c3ef915')) {
      api.createRecord('4c3ef915', component.options)
    } else {
      api.reload('4c3ef915', component.options)
    }
    module.hot.accept("./LowCostForm.vue?vue&type=template&id=4c3ef915&scoped=true&", function () {
      api.rerender('4c3ef915', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/Admin/OfferItemForm/LowCostForm.vue"
export default component.exports